module.exports = __webpack_public_path__ + "img/in-ride-bike.4e72d48c.svg";